import {
  ErrorBoundary,
  addBreadcrumb,
  captureException,
  setContext,
  setTag,
  setUser,
  startInactiveSpan,
} from '@sentry/nextjs';
import { getLoadedReplay, loadReplay } from './load-replay';

export const Sentry = {
  ErrorBoundary,
  addBreadcrumb,
  captureException,
  getReplay: getLoadedReplay,
  setContext,
  setTag,
  setUser,
  startInactiveSpan,
};

type ReplayContext = Record<string, string | number | boolean | null | undefined>;

export const sentryName = (name: string) => name.replace(/-/g, '_');

export const startReplay = async (flow: string, context: ReplayContext = {}) => {
  const normalizedFlow = sentryName(flow);

  Sentry.setTag('flow', normalizedFlow);
  Sentry.setTag('replay.flow', normalizedFlow);
  Sentry.setContext('replay', {
    flow: normalizedFlow,
    ...context,
  });
  Sentry.addBreadcrumb({
    category: 'replay',
    message: `start:${normalizedFlow}`,
    level: 'info',
    data: context,
  });

  const replay = await loadReplay();
  replay?.start();

  setTimeout(() => {
    void flushReplay({ timeoutMs: 1000 });
  }, 1500);
};

export const flushReplay = async ({ timeoutMs = 1500 }: { timeoutMs?: number } = {}) => {
  const replay = Sentry.getReplay?.();
  if (!replay) return;

  try {
    await Promise.race([
      replay.flush(),
      new Promise((resolve) => {
        setTimeout(resolve, timeoutMs);
      }),
    ]);
  } catch {
    // Ignore replay flush errors so login flow is never blocked.
  }
};
